<div style="background-color: white; width: 100%; max-width: 538px; height: auto; display: flex; flex-direction: column; align-items: center; padding: 12px 16px 32px 16px;">
    <div style="width: 100%; display: flex; justify-content: flex-end;">
       <img (click)="closeDialog()" onKeyDown="" src="../../../assets/icons/gray_close.svg" alt="" style="width: 16px; height: 16px; cursor: pointer;"> 
    </div>
    <i class="fa-regular fa-circle-check" style="font-size: 32px; color: green; margin: 17px 0 16px 0;"></i>
    
    <!-- <p class="info-title">Hubo un error al agendar la entrega</p> -->
    <p class="info-title" [innerHTML]="mensaje"></p>    
    <!-- <button (click)="closeDialog()" class="info-cancel-btn">{{ isError?'Regresar':'Continuar'}}</button> -->
    <button (click)="closeDialog()" class="btn btn-success">Continuar</button>
</div>